import AssetCharges from './AssetCharges'

export default AssetCharges
